import type { DigitShape, NegativeStyle } from "@positive/format";

/**
 * Formatting preferences (ADR-0009/D-5, A5). Values come from tenant/user settings once the settings module exists;
 * defaults: Latin digits, minus sign for negatives, no Hijri display, browser time zone.
 */
export interface FormatPreferences {
  region?: string;
  digits: DigitShape;
  negativeStyle: NegativeStyle;
  /** Show the Hijri date next to Gregorian dates (display only, brief §7). */
  showHijri: boolean;
  /** Branch time zone for instants (P8). */
  timeZone?: string;
}

export const defaultFormatPreferences: FormatPreferences = {
  digits: "latn",
  negativeStyle: "minus",
  showHijri: false,
};
